// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604171003/js/" + chunkId + "." + {"44":"54870c09","225":"ccbbb3a0","481":"013f1530","486":"c53b3e7d","770":"2331bee2"}[chunkId] + ".0.4627120827080764.chunk.js";
};